// utils/utils.js
// 将el-icon的组件名称AbbbCddd转化为i-abbb-cddd形式
// 此前用switch做组件名时因关键字重复报错，所以格式统一加了前缀
// 例：Switch转换为i-switch，ArrowDownBold转换为i-arrow-down-bold
export function transElIconName(iconName){
  return 'i'+iconName.replace(/[A-Z]/g,(match)=>'-'+match.toLowerCase())
}
const formatNumber = n => {
n = n.toString()
return n[1] ? n : `0${n}`
}
const formatTime = date => {
if(isBlank(date)){
  return date;
}
const year = date.getFullYear()
const month = date.getMonth() + 1
const day = date.getDate()
const hour = date.getHours()
const minute = date.getMinutes()
const second = date.getSeconds()
return `${[year, month, day].map(formatNumber).join('/')} ${[hour, minute, second].map(formatNumber).join(':')}`
}
const isBlank=(str)=> {
  if(typeof(str)=='number'){
    return false;
  }
  if (Object.prototype.toString.call(str) === '[object Undefined]') {//空
    return true
  } else if (
    Object.prototype.toString.call(str) === '[object String]' ||
    Object.prototype.toString.call(str) === '[object Array]') { //字条串或数组
    return str.length == 0 ? true : false
  } else if (Object.prototype.toString.call(str) === '[object Object]') {
    return JSON.stringify(str) == '{}' ? true : false
  } else {
    return true
  }
}
const getURL = url => {
  if (isBlank(url)) {
    return;
  }
  if (
    url.indexOf(".xls") != -1 ||
    url.indexOf(".xlsx") != -1 ||
    url.indexOf(".doc") != -1 ||
    url.indexOf(".docx") != -1
  ) {
    return (
      "http://view.officeapps.live.com/op/view.aspx?src=" +
      encodeURIComponent(url)
    );
  } else {
    return url;
  }
};
const isImg=img=>{
  if(isBlank(img)){
    return false;
  }
  if(img.indexOf('.xbm')!=-1 || img.indexOf('.tif')!=-1|| img.indexOf('.pjp')!=-1 || img.indexOf('.svgz')!=-1 || img.indexOf('.jpg')!=-1
  || img.indexOf('.jpeg')!=-1||img.indexOf('.ico')!=-1||img.indexOf('.tiff')!=-1||img.indexOf('.gif')!=-1||img.indexOf('.svg')!=-1
  || img.indexOf('.jfif')!=-1 || img.indexOf('.webp')!=-1 || img.indexOf('.png')!=-1|| img.indexOf('.bmp')!=-1 || 
  img.indexOf('.pjpeg')!=-1 || img.indexOf('.avif')!=-1){
    return true;
  }
  return false;
}
const  renderTime=(date)=> {
  var dateee = new Date(date).toJSON();
  return new Date(+new Date(dateee) + 8 * 3600 * 1000).toISOString().replace(/T/g, ' ').replace(/\.[\d]{3}Z/, '')
}
export{
  isImg,
  isBlank,
  getURL,
  formatTime,
  renderTime
}
